module.exports = {
    baseUrl: 'https://openapi.chainge.finance/open/v1'
}